App.controller('LifeWithPaymentsDocumentCtrl', ['$scope', '$stateParams', function ($scope, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'life_document';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Dokumenty do pobrania';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.life.start';
    $scope.$emit('link', $scope.link);
}]);